




























































































































import Vue from 'vue';
import {
  Component, Prop, Watch,
} from 'vue-property-decorator';
import { InterestReward, Tier } from '@/api/product/levelrewards/rewards';
import { ValidationTool } from '@/util';

@Component
export default class InterestRewardEditor extends Vue {
  @Prop()
  value!:InterestReward;

  @Prop()
  level!:number;

  @Prop()
  productHasInterestReward!: boolean;

  @Prop()
  editingExistingReward!: boolean;

  workingReward:InterestReward | null = null;

  tiers: number = 1;

  requiredAndPositiveRule:Array<any> = [ValidationTool.requiredAndPositiveRuleFunction];

  mounted() {
    this.initialize();
  }

  @Watch('value')
  initialize() {
    this.workingReward = this.value.clone() as InterestReward;

    if (this.workingReward.tier3) {
      this.tiers = 3;
    } else if (this.workingReward.tier2) {
      this.tiers = 2;
    } else {
      this.tiers = 1;
    }
  }

  onChange() {
    this.$emit('input', this.workingReward);
  }

  shouldInterestNonQualifyingRateBeShown() : boolean {
    // This is not an edit of an existing reward, only show if there are no existing Interest Rewards
    // on any of the levels.
    return !this.editingExistingReward && !this.productHasInterestReward;
  }

  onNewTiers() {
    if (this.tiers > 1 && !this.workingReward!.tier2) {
        this.workingReward!.tier2 = { apr: '' };
    }

    if (this.tiers === 3 && !this.workingReward!.tier3) {
      this.workingReward!.tier3 = {
        apr: '',
      };
    } else if (this.tiers === 2) {
      this.workingReward!.tier2!.cap = null;
      this.workingReward!.tier3 = null;
    } else {
      this.workingReward!.tier2 = null;
      this.workingReward!.tier3 = null;
      this.workingReward!.tier1.cap = null;
    }
    this.onChange();
  }
}
